import {
  REWARD_POOL_TICKET_CURRENCY,
  RewardPoolTicketCurrency,
} from '@shared/api/types/rewardPools';

import { Hint, HintVariant } from '@ui/uikit/components/common/Hint';

type Props = {
  currency: RewardPoolTicketCurrency;
};

const currenciesTitleMap: Record<RewardPoolTicketCurrency, string> = {
  [REWARD_POOL_TICKET_CURRENCY.SQR]: 'SQR',
  [REWARD_POOL_TICKET_CURRENCY.SQRp]: 'SQRp',
  [REWARD_POOL_TICKET_CURRENCY.USDT]: 'USDT',
  [REWARD_POOL_TICKET_CURRENCY.FREE]: 'Credits',
};

export const DeductionHint = ({ currency }: Props) => {
  return (
    <Hint
      variant={HintVariant.DANGER}
      message={`Once confirmed, the ${currenciesTitleMap[currency]} will be deducted from your Magic ID balance and cannot be canceled.`}
    />
  );
};
